import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 16
class PrintReportQuotationMovement extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined) {
            ReportStore.loadReportCurrentQuotationWork(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined) {
            ReportStore.loadReportCurrentQuotationWorkRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderStatus(status_text) {
        let result = (<span></span>)
        if (status_text=='<span class="label label-default" data-value="0">เริ่มต้น</span>') {
          result = 'เริ่มต้น'
        }else if (status_text=='<span class="label label-warning" data-value="1">อยู่ระหว่างซ่อม</span>') {
          result = 'อยู่ระหว่างซ่อม'
        } else if (status_text=='<span class="label label-primary" data-value="2">รอส่งมอบรถ</span>') {
          result = 'รอส่งมอบรถ'
        } else if (status_text=='<span class="label label-success" data-value="3">ปิดจบงาน</span>') {
          result = 'ปิดจบงาน'
        } else if (status_text=='<span class="label label-purple" data-value="5">ตั้งเบิก</span>') {
          result = 'ตั้งเบิก'
        }
        return result
      }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={23}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item,index)=>{
                  return(
                    <tr key={index}>
                      <td className='text-center'>{(indexs*15)+index+1}</td>
                      <td className='text-center'>{item.quotation_no}</td>
                      <td className='text-left'>{item.insurer_name}</td>
                      <td className='text-center'>{item.insurance_policy_no}</td>
                      <td className='text-center'>{item.claim_no}</td>
                      <td className='text-center'>{item.surveyor}</td>
                      <td className='text-center'>{item.brand}</td>
                      <td className='text-center'>{item.car_registration_no}</td>
                      <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
                      <td className='text-right'>{this.getNumberFormat(item.approved_part)}</td>
                      <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
                      <td className='text-right'>{this.getNumberFormat(item.approved_amount_with_vat)}</td>
                      <td className='text-center'>{item.work_no}</td>
                      <td className='text-center'>{item.work_date}</td>
                      <td className='text-center'>{this.renderStatus(item.status_text)}</td>
                      <td className='text-center'>{item.jobdone_date}</td>
                      <td className='text-center'>{item.appointment_date}</td>
                      <td className='text-center'>{item.delivering_date}</td>
                      <td className='text-center'>{item.delivered_by}</td>
                      <td className='text-center'>{item.invoice_no}</td>
                      <td className='text-center'>{item.invoice_date}</td>
                      <td className='text-right'>{this.getNumberFormat(item.sum_excess)}</td>
                      <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                    </tr>
                  )
                })
            )
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    <tr>
                        <td colSpan={8} className='text-center'>เสนอราคา</td>
                        <td colSpan={4} className='text-center'>คุมราคา</td>
                        <td colSpan={7} className='text-center'>การซ่อม</td>
                        <td colSpan={4} className='text-center'>การเก็บเงิน</td>
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'100px'}}>เลขที่</td>
                        <td className='text-center' style={{minWidth:'100px'}}>ชื่อประกัน</td>
                        <td className='text-center' style={{width:'100px'}}>เลขกรมธรรม์</td>
                        <td className='text-center' style={{width:'100px'}}>เลขเคลม/<br/>แจ้ง</td>
                        <td className='text-center' style={{width:'90px'}}>เจ้าหน้าที่</td>
                        <td className='text-center' style={{width:'90px'}}>ยี่ห้อ</td>
                        <td className='text-center' style={{width:'90px'}}>ทะเบียน</td>
                        <td className='text-center' style={{width:'90px'}}>ค่าแรง<br/>อนุมัติ</td>
                        <td className='text-center' style={{width:'90px'}}>ค่าอะไหล่<br/>อนุมัติ</td>
                        <td className='text-center' style={{width:'90px'}}>รวม</td>
                        <td className='text-center' style={{width:'90px'}}>รวม VAT</td>
                        <td className='text-center' style={{width:'90px'}}>เลขที่<br/>งานซ่อม</td>
                        <td className='text-center' style={{width:'90px'}}>วันที่<br/>เริ่มซ่อม</td>
                        <td className='text-center' style={{width:'90px'}}>สถานะ</td>
                        <td className='text-center' style={{width:'90px'}}>วันที่<br/>ซ่อมเสร็จ</td>
                        <td className='text-center' style={{width:'90px'}}>วันที่<br/>นัดรับ</td>
                        <td className='text-center' style={{width:'90px'}}>วันที่<br/>ส่งรถ</td>
                        <td className='text-center' style={{width:'100px'}}>เจ้าหน้าที่<br/>ส่งรถ</td>
                        <td className='text-center' style={{width:'100px'}}>เลขที่<br/>ใบแจ้งหนี้</td>
                        <td className='text-center' style={{width:'90px'}}>วันที่<br/>วางบิล</td>
                        <td className='text-center' style={{width:'100px'}}>ค่า Excess</td>
                        <td className='text-center' style={{width:'100px'}}>รวมรับสุทธิ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {index===length-1?
                    <tr>
                        <td colSpan={8} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_wage'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_part'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount_with_vat'))}</td>
                        <td colSpan={9} className='text-right'></td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('sum_excess'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportQuotationMovement.defaultProps = {
    title: 'ตารางรายงานความเคลื่อนไหวการเสนอราคา',  
    mode: '',
    workNo: ''
  }
  export default PrintReportQuotationMovement;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportQuotationMovement.js